import ScreenLock from "@/components/ScreenLock/ScreenLock";
import { useTranslate } from "@/hooks";
import { Slide } from "@mui/material";
import { DetailedHTMLProps, FC, HTMLAttributes, useState } from "react";
import cn from "classnames";
import styles from "./CallingLineNavbar.module.scss";
import DatasetBlock from "@/components/DatasetBlock/DatasetBlock";

interface ICallingListNavbar extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
	test?: string; // пример пропса, который может быть передан
}

const CallingListNavbar: FC<ICallingListNavbar> = ({ children, ...props }) => {
	const [showScreenLock] = useState<boolean>(false); // показ экрана блокировки
	const translate = useTranslate(); // hook для перевода текста

	return (
		<>
			<Slide direction="right" in={true} mountOnEnter unmountOnExit timeout={800}>
				<div {...props} className={cn(styles.sidebar)}>
					<DatasetBlock />
					<div className={cn(styles.navbar)}>{children}</div>
				</div>
			</Slide>

			{showScreenLock && <ScreenLock title={translate("title_deletion")} />}
		</>
	);
};

export default CallingListNavbar;
